export function Mark({ className = "h-9 w-auto" }) {
  return (
    <img
      src="/aurea-mark-gold.png"
      alt="Aurea Living mark"
      className={`object-contain ${className}`}
      aria-hidden="true"
    />
  );
}

export default function Logo({ tone = "dark", className = "" }) {
  const main = tone === "light" ? "text-ivory" : "text-ink";
  const sub = tone === "light" ? "text-gold" : "text-bronze";
  return (
    <span
      className={`inline-flex flex-col items-center leading-none select-none ${className}`}
      data-testid="brand-wordmark"
    >
      <span
        className={`font-serif font-medium text-[22px] tracking-[0.3em] pl-[0.3em] ${main}`}
      >
        AUREA
      </span>
      <span
        className={`mt-[5px] text-[7.5px] font-mono uppercase tracking-[0.45em] pl-[0.45em] ${sub}`}
      >
        Luxury Interiors
      </span>
    </span>
  );
}
